export default __webpack_public_path__ + "static/issues-9ffda2b03b6e4695a6163d6d67abc585.jpg";